"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../../common/utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var OrderMapper = exports.default = /*#__PURE__*/function () {
  function OrderMapper() {
    _classCallCheck(this, OrderMapper);
  }
  return _createClass(OrderMapper, [{
    key: "mapToOrder",
    value:
    /**
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
    function mapToOrder(data) {
      var _data$order = data.order,
        order = _data$order === void 0 ? {} : _data$order;
      return (0, _utils.omitNil)({
        billing_address: this.mapToBillingAddress(data),
        coupons: this.mapToCoupons(data),
        currency: order.currency,
        id: order.orderId ? (0, _utils.toString)(order.orderId) : null,
        items: this.mapToItems(data),
        shipping: this.mapToShipping(data),
        shipping_address: this.mapToShippingAddress(data),
        token: order.token,
        totals: this.mapToOrderTotals(data)
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToBillingAddress",
    value: function mapToBillingAddress(data) {
      var _data$customer = data.customer,
        customer = _data$customer === void 0 ? {} : _data$customer;
      var address = this.mapToAddress(data, 'billingAddress');
      if (customer.email) {
        address.email = customer.email;
      }
      return address;
    }

    /**
     * @private
     * @param  {PaymentRequestData} data
     * @return {Shipping[]}
     */
  }, {
    key: "mapToShipping",
    value: function mapToShipping(data) {
      var _ref = data.shippingOption || {},
        description = _ref.description,
        transitTime = _ref.transitTime;
      if (description) {
        return [(0, _utils.omitEmptyStringAndNil)({
          method: description,
          transit_time: transitTime
        })];
      }
      return [];
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Coupon[]}
     */
  }, {
    key: "mapToCoupons",
    value: function mapToCoupons(_ref2) {
      var _ref2$order = _ref2.order,
        order = _ref2$order === void 0 ? {} : _ref2$order;
      if (order.coupon && order.coupon.coupons) {
        return order.coupon.coupons.map(function (_ref3) {
          var code = _ref3.code;
          return {
            code: code
          };
        });
      }
      return [];
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToShippingAddress",
    value: function mapToShippingAddress(data) {
      return this.mapToAddress(data, 'shippingAddress');
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @param {string} addressKey
     * @returns {Object}
     */
  }, {
    key: "mapToAddress",
    value: function mapToAddress(data, addressKey) {
      var address = data[addressKey] || {};
      return (0, _utils.omitEmptyStringAndNil)({
        city: address.city,
        company: address.company,
        country_code: address.countryCode,
        country: address.country,
        first_name: address.firstName,
        last_name: address.lastName,
        phone: address.phone,
        state_code: address.provinceCode,
        state: address.province,
        street_1: address.addressLine1,
        street_2: address.addressLine2,
        zip: address.postCode
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToItems",
    value: function mapToItems(data) {
      var _data$cart = data.cart,
        cart = _data$cart === void 0 ? {
          items: []
        } : _data$cart;
      return cart.items.map(function (itemData) {
        return (0, _utils.omitNil)({
          code: itemData.id,
          variant_id: itemData.variantId,
          name: itemData.name,
          price: itemData.integerAmount,
          unit_price: itemData.integerUnitPrice,
          quantity: itemData.quantity,
          sku: itemData.sku
        });
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToOrderTotals",
    value: function mapToOrderTotals(data) {
      var _data$order2 = data.order,
        order = _data$order2 === void 0 ? {} : _data$order2;
      return (0, _utils.omitNil)({
        grand_total: order.grandTotal ? order.grandTotal.integerAmount : null,
        handling: order.handling ? order.handling.integerAmount : null,
        shipping: order.shipping ? order.shipping.integerAmount : null,
        subtotal: order.subtotal ? order.subtotal.integerAmount : null,
        tax: order.taxTotal ? order.taxTotal.integerAmount : null
      });
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {OrderMapper}
     */
    function create() {
      return new OrderMapper();
    }
  }]);
}();
//# sourceMappingURL=order-mapper.js.map